const theme = {
  breakpoints: [ "480px", "768px", "1024px", "1280px" ],
  color: {
    black: "#2d2d2d",
    darkGray: "#454545",
    lightGray: "#737273",
    lighterGray: "#e4e4e4",
    lightererGray: "#d8d8d8",
    evenLighterGray: "#bdbbbb",
    lightestGrayEver: "#f4f4f4",
    green: "#1f6360",
    beige: "#f8f8f5",
    white: "#ffffff",
    maroon: "#742110",
    peach: "#C97B5E",
    yellow: "#B7852A",
    purple: "#8F6D6E",
  },
  spacing: {
    small: "15px",
    medium: "25px",
    large: "50px",
    xlarge: "75px",
  },
  font: {
    light: "Maison Neue Light, Helvetica, Arial, sans-serif",
    regular: "Maison Neue, Helvetica, Arial, sans-serif",
    book: "Maison Neue Book, Helvetica, Arial, sans-serif",
    demi: "Maison Neue Demi, Helvetica, Arial, sans-serif",
    mono: "Maison Neue Mono, Helvetica, Arial, sans-serif",
  },
  weight: {
    light: 300,
    book: 300,
    regular: 400,
    heavy: 500,
    demi: 500,
    mono: 500,
    extraHeavy: 600
  },
}

export default theme